<template>
<div class="fc-page ft-page"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="ft-breadcrumb"/></nav>
<header class="fc-heading"><div class="fc-child-heading"><h1>学员优惠券</h1><p>查询学员优惠券，查看发放及使用情况</p></div><v-btn @click="showAdd" color="#d9363e" depressed class="ft-create"><v-icon left size="18">mdi-plus</v-icon>给学员发放优惠券</v-btn></header>
<section class="fc-filters" aria-label="学员优惠券筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查询当前校区记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell">
							<v-text-field v-model="query.studentNo" label="学号" dense outlined color="#d9363e" aria-label="学号"></v-text-field>
						</div>
<div class="fc-filter-cell">
							<v-text-field v-model="query.studentName" label="姓名" dense outlined color="#d9363e" aria-label="姓名"></v-text-field>
						</div>
<div class="fc-filter-cell">
							<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
								label="状态" dense outlined color="#d9363e" aria-label="状态"></v-select>
						</div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><div class="fc-filter-actions"><v-btn type="submit" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
<section class="fc-records" aria-label="学员优惠券列表"><div class="fc-list-heading"><h3>学员优惠券列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ft-table ft-student_coupon_list fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">

				<span v-if="item.status=='1'" class="fc-status fc-status-pending">未使用</span>
				<span v-if="item.status=='2'" class="fc-status fc-status-normal">已使用</span>
				<span v-if="item.status=='0'" class="fc-status fc-status-inactive">作废</span>
			</template>
			<template v-slot:item.action="{item}">
				<v-btn @click.stop="frozenStudentCoupon(item)" :disabled="item.status !== '1'" outlined color="#c93640" small>作废</v-btn>
				<v-btn @click.stop="freeStudentCoupon(item)" :disabled="item.status !== '0'" outlined color="#c93640" class="ml-2" small>启用</v-btn>
			</template>


<template v-slot:item.amount="{item}"><span class="fc-number">{{item.amount}}</span></template>
<template v-slot:item.limitAmount="{item}"><span class="fc-number">{{item.limitAmount}}</span></template>
</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e"/></div></section>
<v-dialog title="发放优惠券" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card ft-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-ticket-account</v-icon></span><div><h2>发放优惠券</h2><p>选择学员与优惠券，填写发放备注</p></div><v-spacer/><v-btn icon aria-label="关闭发放优惠券" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-autocomplete :items="selectStudentList" v-model="add.form.studentId"
						        item-text="studentName" item-value="id"
						        label="学员"  dense outlined color="#d9363e" aria-label="学员"></v-autocomplete>
					</v-col>
					<v-col cols="12">
						<v-select :items="selectCouponList" v-model="add.form.couponId"
						item-text="caption" item-value="id" label="优惠券" dense outlined no-data-text="该校区暂无可用优惠券" color="#d9363e" aria-label="优惠券"></v-select>

					</v-col>

					<v-col cols="12">
						<v-text-field label="备注" v-model="add.form.memo" dense outlined color="#d9363e" aria-label="备注"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" color="#65758c" outlined>取消</v-btn>
				<v-btn @click="submitAdd" class="fc-confirm" color="#d9363e" depressed>确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "student-cash-list",
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '学员优惠券',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '学员姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '优惠券名称',
							value: 'couponName',
							sortable: false
						},
						{
							text: '优惠券金额',
							value: 'amount',
							sortable: false
						},
						
						{
							text: '满多少金额可用',
							value: 'limitAmount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '过期时间',
							value: 'expireDate',
							sortable: false
						},
						{
							text: '发放时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectStudentList: [], //选择学生数据源
				selectCouponList: [], //选择优惠券数据源
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "未使用"
					},
					{
						id: "2",
						statusName: "已使用"
					},
					{
						id: "0",
						statusName: "作废"
					},
				],

				query: {
					loading: false,
					page: 1,
					size: 20,
					studentNo: "",
					studentName: "",
					status: ""
				},
				add:{
					dialog:false,
					form:{
						shopId:"",
						studentId:"",
						couponId:"",
						memo:"",
					}
				}
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId()
			this.getTableDataList();
		},
		onLoad(options = {}){
			console.log("onload");
			
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAdd(){
				if(this.selectCouponList.length==0){
					this.getCouponsForSelect();
				}
				
				if (this.selectStudentList.length == 0){
					this.getStudentsForSelect();
				}

				this.add.form.studentId = "";
				this.add.form.couponId = "";
				this.add.form.memo = "";
				
				this.add.dialog = true;
			},
			submitAdd(){
				
				if(!this.add.form.studentId){
					this.$noty.error("请选择学员");
					return
				}
				if(!this.add.form.couponId){
					this.$noty.error("请选择优惠券");
					return
				}
				// api
				const that = this;
				let url = `/financial/student/coupon/create`;
				let postData = {...this.add.form};
				postData.shopId = this.shopId;

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			frozenStudentCoupon(item){
				//冻结
				const that = this;
				let url = `/financial/student/coupon/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeStudentCoupon(item){
				//冻结
				const that = this;
				let url = `/financial/student/coupon/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/financial/student/coupon/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;


				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
			
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "未使用";
				} else if (state === "0") {
					stName = "作废";
				}else if (state === "2") {
					stName = "已使用";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "primary";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}

				return color;
			},
			
		
			getStudentsForSelect(){
				
				const that = this;
				let url = `/edu/shop/student/list/${this.shopId}`;
			
				this.axios.get(url).then(response => {
					
					console.log(response.data["data"]);
					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCouponsForSelect(){
				const that = this;
				let url = `/financial/shop/coupon/list/${this.shopId}`;
				
				
			
				this.axios.get(url).then(response => {
		
					console.log("get coupon",response.data["data"]);
					if (response.data["code"] === 200) {
						that.selectCouponList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/financial-tools.scss"></style>
